export const KEY = 'user';
export const USER_ID_FIELD = 'jti';
export const USER_STATUS = {
  LOADING: 'loading', // fetch is loading
  NOT_AVAILABLE: 'n_a', // user has not been fetched
  FAILED: 'failed', // fetched ok but not logged in
  OK: 'ok' // user is logged in
};
